class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this.closeFacets = this.closeFacets.bind(this);
    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    this.facetButtons = document.querySelectorAll(".facets-button-show");
    this.productGrid = document.getElementById("ProductGridContainer");
    this.facetForm = this.querySelector("form");
    this.facetsWrapper = this.querySelector(".facets__wrapper");
    this.closeButton = this.querySelector(".facets__close");
    this.facetsOverlay = this.querySelector(".facets__overlay");
    this.facetSubmitButton = this.querySelector(".facets__submit");

    this.facetForm?.addEventListener(
      "input",
      this.debouncedOnSubmit.bind(this)
    );

    this.facetForm?.addEventListener(
      "keydown",
      this.onFacetFormKeyDown.bind(this)
    );

    this.facetsWrapper?.addEventListener(
      "keydown",
      this.onHandleKeyDown.bind(this)
    );

    this.facetButtons.forEach((button) =>
      button.addEventListener("click", this.handleShowButtonsClick.bind(this))
    );

    this.closeButton?.addEventListener("click", this.closeFacets);
    this.facetsOverlay?.addEventListener("click", this.closeFacets);
    this.facetSubmitButton?.addEventListener("click", this.closeFacets);
    FacetFiltersForm.handleHeroFilters();
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state
        ? event.state.searchParams
        : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener("popstate", onHistoryChange);
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();

    document
      .getElementById("ProductGridContainer")
      ?.querySelector(".collection")
      ?.classList.add("loading");

    document.querySelectorAll(".facets__reset").forEach((btn) => {
      btn.classList.add("loading");
    });

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [
          ...FacetFiltersForm.filterData,
          { html, url },
        ];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
  }

  static renderProductGridContainer(html) {
    document.getElementById("ProductGridContainer").innerHTML = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById("ProductGridContainer").innerHTML;

    if (
      document.querySelector(".js-load-more") ||
      document.querySelector(".js-infinite-scroll")
    ) {
      initLoadMore();
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, "text/html");

    const facetDetailsElements = parsedHTML.querySelectorAll(
      "#FacetFiltersForm .js-filter"
    );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest(".js-filter") : undefined;
      return jsFilter
        ? element.dataset.index === jsFilter.dataset.index
        : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter(
      (element) => !matchesIndex(element)
    );

    const sourceCurrentFilter =
      Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(
        `.js-filter[data-index="${element.dataset.index}"]`
      ).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderProductCount(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);
    FacetFiltersForm.syncProductTypeFormsByParams(
      FacetFiltersForm.searchParamsPrev
    );

    if (sourceCurrentFilter) {
      FacetFiltersForm.updateCurrentFilter(
        sourceCurrentFilter,
        event.target.closest(".js-filter")
      );
    }

    FacetFiltersForm.handleHeroFilters();

    document.querySelectorAll(".facets__reset").forEach((btn) => {
      btn.classList.remove("loading");
    });
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = [".active-facets"];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;

      document.querySelector(selector).innerHTML =
        activeFacetsElement.innerHTML;
    });
  }

  static renderProductCount(html) {
    const sourceCount = html.getElementById("ProductCount");
    const destinationCount = document.getElementById("ProductCount");
    if (sourceCount && destinationCount) {
      destinationCount.innerHTML = sourceCount.innerHTML;
    }
  }

  static renderAdditionalElements(html) {
    const sourceCount = html?.querySelector(".filters-count");
    const destinationCount = document.querySelector(".filters-count");

    if (sourceCount && destinationCount) {
      destinationCount.innerHTML = sourceCount.innerHTML;

      if (sourceCount.innerHTML == 0) {
        destinationCount.classList.add("hidden");
      } else {
        destinationCount.classList.remove("hidden");
      }
    }
  }

  static updateCurrentFilter(source, target) {
    const sourceCurrentFilterReset = source.querySelector("facet-remove");
    const targetCurrentFilterReset = target.querySelector("facet-remove");
    if (sourceCurrentFilterReset && targetCurrentFilterReset) {
      targetCurrentFilterReset.outerHTML = sourceCurrentFilterReset.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      "",
      `${window.location.pathname}${searchParams && "?".concat(searchParams)}`
    );
  }

  static getSections() {
    return [
      {
        section: document.getElementById("product-grid").dataset.id,
      },
    ];
  }

  static handleHeroFilters() {
    const form = document.querySelector("#FacetFiltersByProductTypeForm");
    if (!form) return;

    const tagItems = form.querySelectorAll(".js-hero-filter");
    const removebtn = document.querySelector(
      "#FacetFiltersByProductTypeForm .js-hero-filter-clear, .collection-hero__filters .js-hero-filter-clear"
    );
    if (!removebtn) return;

    const refresh = () => {
      let someSelected = false;

      tagItems.forEach((item) => {
        const checkbox = item.querySelector('input[type="checkbox"]');
        const isActive = !!(checkbox && checkbox.checked);
        item.classList.toggle("active", isActive);
        if (isActive) someSelected = true;
      });

      removebtn.classList.toggle("active", !someSelected);
    };

    refresh();

    tagItems.forEach((item) => {
      const checkbox = item.querySelector('input[type="checkbox"]');
      if (!checkbox || checkbox.dataset.heroBound) return;
      checkbox.dataset.heroBound = "1";
      checkbox.addEventListener("change", refresh);
    });

    if (!removebtn.dataset.heroBound) {
      removebtn.dataset.heroBound = "1";
      removebtn.addEventListener("click", (e) => {
        e.preventDefault();
        tagItems.forEach((item) => {
          const cb = item.querySelector('input[type="checkbox"]');
          if (cb) cb.checked = false;
          item.classList.remove("active");
        });
        //removebtn.classList.add("disabled");
      });
    }
  }

  static getProductTypeResetSearchParams(searchParams = "") {
    const params = new URLSearchParams(searchParams);

    Array.from(params.keys()).forEach((key) => {
      if (key.startsWith("filter.p.product_type") || key === "page") {
        params.delete(key);
      }
    });

    return params.toString();
  }

  static resetFilterInputs(form) {
    if (!form) return;

    form
      .querySelectorAll(
        'input[name^="filter.p.product_type"], select[name^="filter.p.product_type"]'
      )
      .forEach((input) => {
        if (input.type === "checkbox" || input.type === "radio") {
          input.checked = false;
          return;
        }

        if (input.tagName === "SELECT") {
          input.selectedIndex = 0;
          return;
        }

        input.value = "";
      });
  }

  static syncProductTypeFormsToDefault() {
    const facetFiltersForm = document.querySelector("#FacetFiltersForm");
    const productTypeForm = document.querySelector(
      "#FacetFiltersByProductTypeForm"
    );

    FacetFiltersForm.resetFilterInputs(facetFiltersForm);
    FacetFiltersForm.resetFilterInputs(productTypeForm);

    document
      .querySelectorAll("#FacetFiltersByProductTypeForm .js-hero-filter")
      .forEach((item) => item.classList.remove("active"));

    FacetFiltersForm.handleHeroFilters();
  }

  static syncProductTypeFormsByParams(searchParams = "") {
    const params = new URLSearchParams(searchParams);
    const selectedValues = new Set();

    Array.from(params.keys()).forEach((key) => {
      if (!key.startsWith("filter.p.product_type")) return;

      params.getAll(key).forEach((value) => {
        selectedValues.add(value);
      });
    });

    document
      .querySelectorAll('input[name^="filter.p.product_type"][type="checkbox"]')
      .forEach((input) => {
        input.checked = selectedValues.has(input.value);
      });

    FacetFiltersForm.handleHeroFilters();
  }

  syncProductTypeInputState(sourceInput) {
    if (!sourceInput || !sourceInput.name?.startsWith("filter.p.product_type"))
      return;

    const sourceForm = sourceInput.closest("form");
    if (!sourceForm || sourceForm.id !== "FacetFiltersForm") return;

    const productTypeForm = document.querySelector(
      "#FacetFiltersByProductTypeForm"
    );
    if (!productTypeForm) return;

    productTypeForm
      .querySelectorAll(`input[name="${sourceInput.name}"]`)
      .forEach((input) => {
        if (input.value === sourceInput.value) {
          input.checked = sourceInput.checked;
        }
      });

    FacetFiltersForm.handleHeroFilters();
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    this.syncProductTypeInputState(event.target);

    const sortFilterForms = document.querySelectorAll(
      "facet-filters-form form"
    );

    const forms = [];

    const currentForm = event.target.closest("form");

    sortFilterForms.forEach((form) => {
      if (
        form.id === "FacetSortForm" ||
        form.id === "FacetFiltersForm" ||
        form.id === "FacetFiltersByProductTypeForm"
      ) {
        const noJsElements = document.querySelectorAll(".no-js-list");
        noJsElements.forEach((el) => el.remove());

        if (currentForm === form) {
          forms.push(this.createSearchParams(form));
        } else {
          const searchParamsWithoutProductType =
            this.createSearchParams(form)
              ?.split("&")
              ?.filter(
                (element) => !element.startsWith("filter.p.product_type")
              )
              ?.join("&") || "";

          forms.push(searchParamsWithoutProductType);
        }
      }
    });
    this.onSubmitForm(forms.join("&"), event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();

    const url =
      event.currentTarget.href.indexOf("?") == -1
        ? ""
        : event.currentTarget.href.slice(
            event.currentTarget.href.indexOf("?") + 1
          );

    const parentFilter = event.currentTarget.closest(".js-filter");
    const isProductTypeFilterReset = !!(
      parentFilter &&
      parentFilter.querySelector('input[name^="filter.p.product_type"]')
    );
    const isClearAllAction = !!event.currentTarget.closest(".remove-all");

    const isProductTypeClearAction =
      isClearAllAction ||
      isProductTypeFilterReset ||
      !!event.currentTarget.closest(
        "#FacetFiltersByProductTypeForm .js-hero-filter-clear"
      );

    if (isProductTypeClearAction) {
      FacetFiltersForm.syncProductTypeFormsToDefault();
      FacetFiltersForm.renderPage(
        FacetFiltersForm.getProductTypeResetSearchParams(url)
      );
      return;
    }

    FacetFiltersForm.renderPage(url);
  }

  handleFacetButtonClick(event) {
    event.preventDefault();

    if (!this.facetButtons.length || !this.facetForm || !this.facetsWrapper)
      return;

    const panel = this.facetsWrapper.querySelector(".facets__inner");
    if (panel && this._onCloseEnd) {
      panel.removeEventListener("transitionend", this._onCloseEnd);
      this._onCloseEnd = null;
    }
    if (this._closeTimer) {
      clearTimeout(this._closeTimer);
      this._closeTimer = null;
    }
    this.facetsWrapper.classList.remove("closing");

    if (this.facetsWrapper.classList.contains("active")) return;

    this.facetsWrapper.classList.add("active");

    this.focusElement = event.target.closest(".facets-button-show")
      ? event.target
      : document.activeElement;

    if (
      this.classList.contains("facets--drawer") ||
      this.classList.contains("facets--sticky")
    ) {
      document.body.classList.add("overflow-hidden");
    } else {
      document.body.classList.add("overflow-hidden-mobile-facets");
    }

    const dialog = this.querySelector('[role="dialog"]');
    const trapTarget = panel || this;

    if (this._onOpenEnd) {
      trapTarget.removeEventListener("transitionend", this._onOpenEnd);
      this._onOpenEnd = null;
    }
    if (this._openTimer) {
      clearTimeout(this._openTimer);
      this._openTimer = null;
    }

    const doTrap = () => {
      if (this._onOpenEnd) {
        trapTarget.removeEventListener("transitionend", this._onOpenEnd);
        this._onOpenEnd = null;
      }
      if (this._openTimer) {
        clearTimeout(this._openTimer);
        this._openTimer = null;
      }
      trapFocus(this, dialog);
    };

    this._onOpenEnd = (e) => {
      if (e.target !== trapTarget) return;
      doTrap();
    };

    trapTarget.addEventListener("transitionend", this._onOpenEnd);

    const durationMs =
      (parseFloat(getComputedStyle(trapTarget).transitionDuration) || 0) * 1000;
    this._openTimer = setTimeout(doTrap, (durationMs || 300) + 50);
  }

  closeFacets(event) {
    event?.preventDefault();

    if (!this.facetsWrapper) return;
    if (!this.facetsWrapper.classList.contains("active")) return;
    if (this.facetsWrapper.classList.contains("closing")) return;

    const panel = this.facetsWrapper.querySelector(".facets__inner");
    if (!panel) return;

    if (this._onCloseEnd) {
      panel.removeEventListener("transitionend", this._onCloseEnd);
      this._onCloseEnd = null;
    }
    if (this._closeTimer) {
      clearTimeout(this._closeTimer);
      this._closeTimer = null;
    }

    this.facetsWrapper.classList.add("closing");

    const cleanup = () => {
      if (this._onCloseEnd) {
        panel.removeEventListener("transitionend", this._onCloseEnd);
        this._onCloseEnd = null;
      }
      if (this._closeTimer) {
        clearTimeout(this._closeTimer);
        this._closeTimer = null;
      }

      this.facetsWrapper.classList.remove("active", "closing");
      removeTrapFocus(this.focusElement);
      document.body.classList.remove(
        "overflow-hidden",
        "overflow-hidden-mobile-facets"
      );
    };

    this._onCloseEnd = (e) => {
      if (e.target !== panel) return;
      cleanup();
    };

    panel.addEventListener("transitionend", this._onCloseEnd);

    const durationMs =
      (parseFloat(getComputedStyle(panel).transitionDuration) || 0) * 1000;
    this._closeTimer = setTimeout(cleanup, (durationMs || 300) + 50);
  }

  onHandleKeyDown(event) {
    const isEnterOnFacetInput =
      event.key === "Enter" &&
      event.target?.matches(
        '.facets__inner-filters input[type="checkbox"], .facets__inner-filters input[type="radio"]'
      );

    if (isEnterOnFacetInput) {
      event.preventDefault();
      if (!event.target.disabled) {
        event.target.click();
      }
      return;
    }

    if (
      event.key === "Escape" &&
      this.facetsWrapper?.classList.contains("active")
    ) {
      this.closeFacets(event);
    }
  }

  onFacetFormKeyDown(event) {
    const isKeyboardActivationKey =
      event.key === "Enter" || event.key === " " || event.key === "Spacebar";

    if (!isKeyboardActivationKey) return;

    const targetLabel = event.target?.closest(
      "#FacetFiltersByProductTypeForm .js-hero-filter label[for], #FacetFiltersForm .facets__inner-filters label[for]"
    );

    if (!targetLabel) return;

    event.preventDefault();

    const inputId = targetLabel.getAttribute("for");
    if (!inputId) return;

    const input = document.getElementById(inputId);
    if (!input || input.disabled) return;

    input.click();
  }

  handleShowButtonsClick(event) {
    event.preventDefault();

    // targetId - FacetFiltersForm or FacetSortForm
    const targetId =
      event.currentTarget.dataset.desktopModal ||
      event.currentTarget.dataset.mobileModal;

    const targetForm = document.querySelector(
      `[data-filters-form="${targetId}"]`
    );
    if (!targetForm) return;
    targetForm.handleFacetButtonClick(event);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define("facet-filters-form", FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll("input").forEach((element) =>
      element.addEventListener("change", this.onRangeChange.bind(this))
    );
    this.setMinAndMaxValues();
    this.controlSlider();
    this.controlInput();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll(".field__input");
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute("max", maxInput.value);
    if (minInput.value) maxInput.setAttribute("min", minInput.value);
    if (minInput.value === "") {
      maxInput.setAttribute("min", 0);
    }
    if (maxInput.value === "") {
      minInput.setAttribute("max", maxInput.getAttribute("max"));
    }
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute("min"));
    const max = Number(input.getAttribute("max"));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }

  fillSlider() {
    const inputRangeWrappers = document.querySelectorAll(
      ".facets__price .facets__range"
    );
    inputRangeWrappers.forEach((inputWrapper) => {
      const inputsRange = inputWrapper.querySelectorAll(".field__range");
      const inputRangeFrom = inputsRange[0];
      const inputRangeTo = inputsRange[1];

      const range = Number(inputRangeTo.max) - Number(inputRangeTo.min);
      const fromCurrent =
        Number(inputRangeFrom.value) - Number(inputRangeTo.min);
      const toCurrent = Number(inputRangeTo.value) - Number(inputRangeTo.min);
      const minRange = (fromCurrent / range) * 100;
      const maxRange = (toCurrent / range) * 100;

      inputWrapper.setAttribute(
        "style",
        `--range-min: ${minRange}%; --range-max: ${maxRange}%`
      );
    });
  }

  controlSlider() {
    const inputRangeWrappers = document.querySelectorAll(
      ".facets__price .facets__range"
    );
    const inputNumberWrappers = document.querySelectorAll(
      ".facets__price .facets__price-wrapper"
    );

    inputRangeWrappers.forEach((inputWrapper, index) => {
      const inputsRange = inputWrapper.querySelectorAll(".field__range");
      const inputRangeFrom = inputsRange[0];
      const inputRangeTo = inputsRange[1];
      const inputNumberFrom =
        inputNumberWrappers[index].querySelectorAll(".field__input")[0];
      const inputNumberTo =
        inputNumberWrappers[index].querySelectorAll(".field__input")[1];

      inputRangeFrom.oninput = () => {
        const from = Number(inputRangeFrom.value);
        const to = Number(inputRangeTo.value);
        if (from > to) {
          inputRangeFrom.value = to;
          inputNumberFrom.value = to;
        } else {
          inputNumberFrom.value = from;
        }

        this.fillSlider();
      };

      if (Number(inputRangeTo.value) <= 0) {
        inputRangeTo.style.zIndex = 2;
      } else {
        inputRangeTo.style.zIndex = 0;
      }

      inputRangeTo.oninput = () => {
        const from = Number(inputRangeFrom.value);
        const to = Number(inputRangeTo.value);
        if (from <= to) {
          inputRangeTo.value = to;
          inputNumberTo.value = to;
        } else {
          inputNumberTo.value = from;
          inputRangeTo.value = from;
        }

        if (Number(inputRangeTo.value) <= 0) {
          inputRangeTo.style.zIndex = 2;
        } else {
          inputRangeTo.style.zIndex = 0;
        }

        this.fillSlider();
      };
    });
  }

  controlInput() {
    const inputRangeWrappers = document.querySelectorAll(
      ".facets__price .facets__range"
    );
    const inputNumberWrappers = document.querySelectorAll(
      ".facets__price .facets__price-wrapper"
    );

    inputNumberWrappers.forEach((inputWrapper, index) => {
      const inputsNumber = inputWrapper.querySelectorAll(".field__input");
      const inputNumberFrom = inputsNumber[0];
      const inputNumberTo = inputsNumber[1];
      const inputRangeFrom =
        inputRangeWrappers[index].querySelectorAll(".field__range")[0];
      const inputRangeTo =
        inputRangeWrappers[index].querySelectorAll(".field__range")[1];

      inputNumberFrom.oninput = () => {
        const from = Number(inputNumberFrom.value);
        const to = Number(inputNumberTo.value);

        if (to && from > to) {
          inputRangeFrom.value = to;
        } else {
          inputRangeFrom.value = from;
        }

        this.fillSlider();
      };

      inputNumberTo.oninput = () => {
        const from = Number(inputNumberFrom.value);
        const to = Number(inputNumberTo.value);

        if (to >= from) {
          inputRangeTo.value = to;
        } else {
          inputRangeTo.value = from;
        }

        this.fillSlider();
      };

      inputNumberFrom.onblur = () => {
        if (inputNumberFrom.value === "") return;
        const from = Number(inputNumberFrom.value);
        const min = Number(inputNumberFrom.getAttribute("min"));
        const max = Number(inputNumberFrom.getAttribute("max"));

        if (from < min) {
          inputRangeFrom.value = min;
          inputNumberFrom.value = min;
        } else {
          inputRangeFrom.value = from;
        }

        this.fillSlider();
      };

      inputNumberTo.onblur = () => {
        if (inputNumberTo.value === "") return;
        const to = Number(inputNumberTo.value);
        const min = Number(inputNumberTo.getAttribute("min"));
        const max = Number(inputNumberTo.getAttribute("max"));

        if (to > max) {
          inputRangeTo.value = max;
          inputNumberTo.value = max;
        } else {
          inputRangeTo.value = to;
        }

        this.fillSlider();
      };
    });
  }
}

customElements.define("price-range", PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector("a");
    facetLink.setAttribute("role", "button");
    facetLink.addEventListener("click", this.closeFilter.bind(this));
    facetLink.addEventListener("keyup", (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === "SPACE") this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form =
      this.closest("facet-filters-form") ||
      document.querySelector("facet-filters-form");
    form.onActiveFilterClick(event);
    form.render;
  }
}

customElements.define("facet-remove", FacetRemove);

if (typeof window.initFacetStickyBar !== "function") {
  let scrollHandler = null;

  const updateFacetStickyLayout = () => {
    const stickyBar = document.querySelector(".facet-filters-sticky");
    const gridContainer = document.getElementById("ProductGridContainer");

    if (!stickyBar || !gridContainer) return;

    const rect = gridContainer.getBoundingClientRect();
    const isRtl = document.documentElement.getAttribute("dir") === "rtl";
    const offset = isRtl
      ? document.documentElement.clientWidth - rect.right
      : rect.left;

    stickyBar.style.setProperty(
      "--facet-sticky-offset",
      `${Math.max(offset - 25, 0)}px`
    );

    //const bottomOffset = parseFloat(getComputedStyle(stickyBar).bottom) || 0;
    //gridContainer.style.setProperty(
    //  "--facet-sticky-reserved-space",
    //  `${stickyBar.offsetHeight + bottomOffset}px`
    //);
  };

  window.addEventListener("resize", updateFacetStickyLayout);

  window.initFacetStickyBar = function initFacetStickyBar() {
    const topBlock = document.querySelector(".main-collection__top");
    const stickyBar = document.querySelector(".facet-filters-sticky");
    const footerEl = document.querySelector(".footer");
    const gridContainer = document.getElementById("ProductGridContainer");

    if (!stickyBar || !topBlock) return;

    const getHeaderHeight = () => {
      const val = getComputedStyle(document.documentElement)
        .getPropertyValue("--header-height")
        .trim();
      return parseFloat(val) || 0;
    };

    const isElementBelowScroll = (element) => {
      return element ? element.getBoundingClientRect().top > 0 : false;
    };

    const updateStickyBarState = () => {
      const topBlockVisible = isElementBelowScroll(topBlock);
      const footerReached = footerEl
        ? footerEl.getBoundingClientRect().top <= window.innerHeight
        : false;

      if (topBlockVisible || footerReached) {
        stickyBar.classList.remove("active");
      } else {
        stickyBar.classList.add("active");
      }
    };

    const handleIntersect = () => {
      updateStickyBarState();
    };

    const createObserver = () => {
      const headerHeight = getHeaderHeight();
      return new IntersectionObserver(handleIntersect, {
        root: null,
        rootMargin: `-${headerHeight}px 0px 0px 0px`,
        threshold: 0.01,
      });
    };

    let observer = createObserver();
    if (topBlock) observer.observe(topBlock);
    if (footerEl) observer.observe(footerEl);

    if (scrollHandler) {
      window.removeEventListener("scroll", scrollHandler);
    }
    scrollHandler = updateStickyBarState;
    window.addEventListener("scroll", scrollHandler, { passive: true });
    updateStickyBarState();

    updateFacetStickyLayout();
    if (gridContainer) {
      new ResizeObserver(updateFacetStickyLayout).observe(gridContainer);
    }

    // Recreate observer when header height changes (responsive breakpoints)
    const headerEl = document.querySelector(".shopify-section-header");
    if (headerEl) {
      new ResizeObserver(() => {
        observer.disconnect();
        observer = createObserver();
        if (topBlock) observer.observe(topBlock);
        if (footerEl) observer.observe(footerEl);
      }).observe(headerEl);
    }
  };

  window.initFacetStickyBar();

  document.addEventListener("shopify:section:load", () => {
    window.initFacetStickyBar();
  });
}
